import { render, staticRenderFns } from "./videoRanking.vue?vue&type=template&id=847f8bf4&scoped=true"
import script from "./videoRanking.vue?vue&type=script&lang=js"
export * from "./videoRanking.vue?vue&type=script&lang=js"
import style0 from "./videoRanking.vue?vue&type=style&index=0&id=847f8bf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847f8bf4",
  null
  
)

export default component.exports